import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { loanService } from '../../services/loanService';

export const useGetPersonalGuaranteeList = params => {
  return useQuery({
    staleTime: Infinity,
    queryKey: [QUERY_KEYS.loan.fpg_list, params],
    queryFn: () =>
      loanService.personalGuarantees(params).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
      }),
  });
};
